<div class="page-head">
    <app-header></app-header>
</div>

<div class="page-content has-header">
    <router-outlet></router-outlet>
</div>

